import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { EyeIcon, EyeSlashIcon } from "wm-graphics";
import "./PasswordField.scss";

export class PasswordField extends React.Component {
  static defaultProps = {
    disabled: false,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Callback function for when PasswordField's input is changed */
    onChange: PropTypes.func,
    /** Callback function for when the PasswordField is clicked */
    onClick: PropTypes.func,
    /** Whether the text field's input can be changed */
    disabled: PropTypes.bool,
    /** Error message to show */
    errorMessage: PropTypes.string,
    /** Id associated with component */
    id: PropTypes.any,
    /** Label associated with component */
    label: PropTypes.string,
    /** Placeholder associated with component */
    placeholder: PropTypes.string,
    /** If input should autofocus */
    autoFocus: PropTypes.bool,
    /** Callback function when a key is pressed */
    onKeyDown: PropTypes.func,
    /** Boolean to determine whether to show toggle eye icon */
    showVisibilityToggle: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      passwordVisible: false,
      value: "",
    };
  }

  onChange = (event) => {
    const { disabled, id, onChange } = this.props;

    const { value } = event.target;

    this.setState({ value });

    if (!disabled) {
      if (onChange) {
        if (id) {
          onChange({
            id,
            value,
          });
        } else {
          onChange(value);
        }
      }
    }
  };

  onClick = (event) => {
    const { onClick } = this.props;

    if (onClick) {
      onClick(event);
    }
  };

  onKeyDown = (event) => {
    const { onKeyDown } = this.props;
    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  onVisibilityToggleClick = () => {
    const { passwordVisible } = this.state;

    this.setState({ passwordVisible: !passwordVisible });
  };

  onVisibilityToggleKeyDown = (event) => {
    const { passwordVisible } = this.state;

    if (event.key === "Enter") {
      this.setState({ passwordVisible: !passwordVisible });
    }
  };

  renderVisibilityToggle = () => {
    const { passwordVisible } = this.state;

    return passwordVisible ? (
      <EyeSlashIcon data-testid="eye-slash-icon" />
    ) : (
      <EyeIcon data-testid="eye-icon" />
    );
  };

  render() {
    const {
      autoFocus,
      className,
      disabled,
      errorMessage,
      id,
      label,
      placeholder,
      showVisibilityToggle,
    } = this.props;

    const { passwordVisible, value } = this.state;

    const inputType = passwordVisible ? "text" : "password";

    const passwordFieldClass = classNames(
      "passwordField",
      { "passwordField--disabled": disabled },
      { "passwordField--error": errorMessage },
      className
    );
    return (
      <div className={passwordFieldClass}>
        {label && <label htmlFor={id}>{label}</label>}
        <div className="passwordField__input">
          <input
            id={id}
            className="input__box"
            data-testid="password-input"
            type={inputType}
            tabIndex={0}
            onChange={this.onChange}
            onClick={this.onClick}
            onKeyDown={this.onKeyDown}
            placeholder={placeholder}
            value={value}
            autoFocus={autoFocus}
          />
          {showVisibilityToggle && (
            <div
              className="input__visibilityIcon"
              data-testid="visibility-icon"
              onClick={this.onVisibilityToggleClick}
              onKeyDown={this.onVisibilityToggleKeyDown}
              role="button"
              tabIndex={0}
            >
              {this.renderVisibilityToggle()}
            </div>
          )}
        </div>
        {errorMessage && (
          <div className="passwordField__message">{errorMessage}</div>
        )}
      </div>
    );
  }
}

export default PasswordField;
